import { Helmet } from 'react-helmet-async';
import { useEdicao } from '../hooks/useEdicao';
import { SiteNav } from '../components/home/SiteNav';
import { Hero2027 } from '../components/home/Hero2027';
import { PreInscricaoAviso, SobreKairos, PrimeiroLote, Investimento2027, SectionTitle } from '../components/home/Sections2027';
import { Depoimentos, Idealizador, FaqSection, ContatoSection, SiteFooter, CtaFinal } from '../components/home/Sections2027b';
import { PreInscricaoForm } from '../components/PreInscricaoForm';
import { MemoriasSection } from '../components/home/MemoriasSection';
import { ClipboardList } from 'lucide-react';

const SITE_URL = 'https://kairosseminarios.com.br';

export default function Home2027() {
  const { edicao, periodo, local } = useEdicao();
  const title = `Encontro de Casais Kairós ${edicao.ano} | Pré-inscrições Abertas`;
  const description = `O Encontro de Casais Kairós ${edicao.ano} acontecerá de ${periodo}. Realize sua pré-inscrição e acompanhe a divulgação do primeiro lote.`;

  const eventJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Event',
    name: edicao.nome,
    startDate: edicao.data_inicio,
    endDate: edicao.data_fim,
    eventStatus: 'https://schema.org/EventScheduled',
    eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode',
    description,
    organizer: { '@type': 'Organization', name: 'Seminário Psicoteológico Kairós', url: SITE_URL },
    url: SITE_URL,
    image: `${SITE_URL}/logo-kairos.png`,
  };
  if (edicao.local_confirmado && edicao.local_nome) {
    eventJsonLd.location = { '@type': 'Place', name: edicao.local_nome, address: edicao.local_cidade || undefined };
  }

  return (
    <div className="min-h-screen bg-obsidian" data-testid="home-2027">
      <Helmet
        title={title}
        link={[{ rel: 'canonical', href: `${SITE_URL}/` }]}
        meta={[
          { name: 'description', content: description },
          { property: 'og:type', content: 'website' },
          { property: 'og:title', content: title },
          { property: 'og:description', content: description },
          { property: 'og:url', content: `${SITE_URL}/` },
          { property: 'og:image', content: `${SITE_URL}/og-kairos-2027.jpg` },
          { property: 'og:locale', content: 'pt_BR' },
          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:title', content: title },
          { name: 'twitter:description', content: description },
          { name: 'twitter:image', content: `${SITE_URL}/og-kairos-2027.jpg` },
        ]}
        script={[{ type: 'application/ld+json', innerHTML: JSON.stringify(eventJsonLd) }]}
      />

      <SiteNav />
      <Hero2027 edicao={edicao} periodo={periodo} local={local} />
      <PreInscricaoAviso periodo={periodo} />
      <SobreKairos />
      <Depoimentos />
      <Idealizador />
      <MemoriasSection />
      <PrimeiroLote />
      <Investimento2027 ano={edicao.ano} />

      <section id="pre-inscricao" className="py-24 bg-obsidian-100 scroll-mt-20" data-testid="home-pre-inscricao-section">
        <div className="container mx-auto px-4">
          <SectionTitle eyebrow="PRÉ-INSCRIÇÃO" icon={ClipboardList} title={<>Façam a <span className="text-kairos-orange">pré-inscrição</span> do casal</>} subtitle="Leva menos de um minuto. Vocês receberão em primeira mão a abertura do primeiro lote." />
          <div className="max-w-3xl mx-auto rounded-2xl border border-white/10 bg-obsidian/60 backdrop-blur p-6 md:p-10">
            <PreInscricaoForm periodo={periodo} compact />
          </div>
        </div>
      </section>

      <FaqSection periodo={periodo} local={local} />
      <ContatoSection whatsapp={edicao.whatsapp_contato} ano={edicao.ano} />
      <CtaFinal ano={edicao.ano} />
      <SiteFooter />
    </div>
  );
}
